// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import { createSelector } from 'reselect';
import { useSelector } from 'react-redux';
import { selectedCountryInfoSelector } from '../countries';

export const provincesSelector = createSelector(
    (state: any) => state.provinces,
    res => (countryCode: any) => res[countryCode]
);

export function useCurrentCountryAndProvinces() {
    const countryInfo = useSelector(state =>
        selectedCountryInfoSelector(state)
    );
    const country = countryInfo && countryInfo.countryShortCode;
    const provinceOptions = useSelector((state: any) =>
        provincesSelector(state)(country.toLocaleLowerCase())
    );
    return { ...countryInfo, provinces: provinceOptions };
}
